import { render, staticRenderFns } from "./QuestionnaireScorePopup.vue?vue&type=template&id=45dd93cb&"
import script from "./QuestionnaireScorePopup.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireScorePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports